import _typeof from "@babel/runtime/helpers/esm/typeof";
export default function isObject(value) {
  return _typeof(value) === 'object' && value !== null && !Array.isArray(value);
}